import(/* webpackMode: "eager" */ "/home/circleci/project/app-src/src/app/global-error.tsx");
